<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/simple'
import userHasPermissions from '@utils/userPermissions'

export default {
  page: {
    title: 'Home',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
  },
  data() {
    return {
      dashboardComponent: 'Dashboard',
    }
  },
  computed: {
    rolesForDashboard() {
      return ['SUPERUSER', 'REPORTS_OPERATOR']
    },
  },
  created() {
    if (this.hasRolesForDashboard()) {
      this.$router.push({ name: 'dashboard' })
    }
  },
  methods: {
    hasRolesForDashboard() {
      return userHasPermissions(
        this.$store.state.auth.userRole,
        this.rolesForDashboard
      )
    },
  },
}
</script>

<template>
  <Layout>
    <div/>
  </Layout>
</template>
